import { render, staticRenderFns } from "./WebTestSpeichernBase.vue?vue&type=template&id=960dd2e2&scoped=true"
import script from "./WebTestSpeichernBase.vue?vue&type=script&lang=ts"
export * from "./WebTestSpeichernBase.vue?vue&type=script&lang=ts"
import style0 from "./WebTestSpeichernBase.vue?vue&type=style&index=0&id=960dd2e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960dd2e2",
  null
  
)

export default component.exports